import React from 'react';
import styles from './ServiceUnavailable.css';
import StaticNavigation from './StaticPages/StaticNavigation';

const ServiceUnavailable = () => (
  <div>
    <StaticNavigation title="503" />
    <div className={styles.container}>
      <h1 className={styles.header}>
        We are currently working on improving your shopping experience.
      </h1>
      <p className={styles.pstyle}>Please check back shortly!</p>
    </div>
  </div>
);

export default ServiceUnavailable;



// WEBPACK FOOTER //
// ./src/components/ServiceUnavailable.jsx